// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__hxqTD","amount":"Amount_amount__SvH4o","tip":"Amount_tip__1NTUN","tipHeader":"Amount_tipHeader__2xzWr","tipsWrap":"Amount_tipsWrap__1wJNW"};